import React from "react";
import { useParams, Navigate } from "react-router-dom";
import AuthorityPage from "@/components/AuthorityPage";
import { CASE_STUDIES } from "@/lib/authorityContent";

export default function CaseStudy() {
  const { slug } = useParams();
  const cs = CASE_STUDIES[slug];
  if (!cs) return <Navigate to="/case-studies" replace />;
  return <AuthorityPage {...cs} pageType="Article" testid={`case-study-${slug}`} />;
}
